export default "__VITE_ASSET__R$$jw0oO__"